// keep same file as beginning, we only remove lines which was imported
export var downloadErrorCsv = function (fileContent, info) {
    var fileRows = fileContent.split(/\n/g);
    var users = fileRows.slice(1).filter(function (row) { return row.trim().length > 0; });
    var userNotImported = users.filter(function (item, index) {
        var itemInResultByIndex = info[index];
        return !itemInResultByIndex.userCreated && !itemInResultByIndex.userUpdated;
    });
    var outputCsvContent = userNotImported.join('\n');
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(outputCsvContent));
    element.setAttribute('download', 'import_failed-users.csv');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};
